import { Component, Input, HostListener } from '@angular/core';
import { DataService, MainService } from '../../../services'

@Component({
  selector: 'event-ouinon',
  styleUrls: ['../../../app.component.css'],
  template: `
    <div class="udo-pop" [style.z-index]="_altitude">
      <div class="udo-pop-dialog" style="min-width:300px;max-width:90%;background:white">
        <div class="udo-pop-title pop-title-blue">
          <i class="ion-icons ion-information-circled" style="margin-right:10px;font-size:30px" aria-hidden="true"></i>
          <span>Confirmation</span>
        </div>
        <div class="udo-pop-content">
          <span class="info">{{msg}}</span>
        </div>
        <div class="udo-pop-bottom">
          <button class="btn btn-gris" (click)="close(false)">Non</button>
          <button class="btn btn-gris" (click)="close(true)" style="background-color:rgba(13,87,136,.7)">Oui</button>
        </div>
      </div>
    </div>
  `
})
export class EventOuiNonComponent {

  public msg: string;
  public _altitude;
  private _guid;

  constructor(
    private dataService: DataService,
    private mainService: MainService
    ) {
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.close(true);
    } else if (event.key === 'Escape') {
      this.close(false);
    }
  }

  @Input()
  public set altitude(altitude) {
    this._altitude = altitude;
  }

  @Input()
  public set guid(guid) {
    this._guid = guid;
  }

  @Input()
  public set param(param) {
    this.msg = param;
  }

  ngOnInit(): void {
  }

  close(result: boolean): void {
    if (result) {
      this.mainService.dialogConfirmation();
    } else {
      this.mainService.dialogRejection();
    }
    this.dataService.removePopup(this._guid);
  }

}
